const bridge = () =>
  typeof window !== "undefined" ? window.desktopOfflineProfile : null;

const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline profile storage.");
  return api;
};

const cleanError = (error) => {
  const message = String(error?.message || error || "Offline profile operation failed.")
    .replace(/^Error invoking remote method '[^']+':\s*(?:Error:\s*)?/i, "")
    .replace(/^Error:\s*/i, "")
    .trim();
  return new Error(message || "Offline profile operation failed.");
};

const invoke = async (operation) => {
  try {
    return await operation();
  } catch (error) {
    throw cleanError(error);
  }
};

export const getOfflineProfile = (restaurantId) =>
  invoke(() => requireBridge().get({ restaurantId }));

export const saveOfflineProfile = (restaurantId, profile) =>
  invoke(() => requireBridge().save({ restaurantId, profile }));
